import * as React from "react";
import { IAdjustCostProps } from "./IAdjustCost";
import { RootState } from "../../rootReducer";
import {
    removeWindowBeforeUnload,
    // dateFormatter,
    specialCharacterCheck,
    dropCheck,
} from "../../utils/utils";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import * as dynamicFormActionCreators from "../DynamicForm/actionCreators";
import * as globalActionsCreator from "../../globalStore/actions";
import * as TransactionActionCreator from "../ThankYou/actionCreators";
import ReactGA from "react-ga";
import "../../../assets/sass/components/adjustCost.scss";
import "../../../assets/sass/widgets/datePickerWidget.scss";
import { CurrencyInput } from "../../utils/numberMask";
import * as CONFIG from "../../../config.json";
import { imagePathurl } from "../../utils/utils";

interface IAdjustCostStateProps {
    checked?: any;
    openCalendar: any;
    hidebucks?: any;
    date: any;
    todaysDate: any;
    warrantyCost: any;
    TotatlWarrantyCost: any;
    ActualWarrantyCost?: any;
    Currency: any;
    CheckAmount: any;
    CheckCurrency: any;
    CheckNumber: any;
    CheckDepositDate: any;
    CheckAmountError: any;
    CheckNumberError: any;
    TotatlWarrantyCostError: any;
    CheckDepositDateError: any;
    isCurrencyDropDown: any;
    isCheckCurrencyDropDown: any;
    maximum: any;
}
class AdjustCost extends React.Component<IAdjustCostProps, IAdjustCostStateProps> {
    node: any;
    constructor(props) {
        super(props);
        this.state = {
            isCurrencyDropDown: false,
            isCheckCurrencyDropDown: false,
            openCalendar: false,
            checked: false,
            hidebucks: false,
            date: new Date(),
            todaysDate: new Date(),
            warrantyCost: 0.0,
            ActualWarrantyCost: "",
            TotatlWarrantyCost: "",
            Currency: "USD",
            CheckAmount: 0.0,
            CheckCurrency: "USD",
            CheckNumber: "",
            CheckDepositDate: "",
            TotatlWarrantyCostError: "",
            CheckAmountError: "",
            CheckNumberError: "",
            CheckDepositDateError: "",
            maximum: 9999999.99,
        };
        this.handlePopupClose = this.handlePopupClose.bind(this);
        this.totalWarrantyCost = this.totalWarrantyCost.bind(this);
        this.completePayment = this.completePayment.bind(this);
        this.updateCheckAmount = this.updateCheckAmount.bind(this);
        this.handleCheckNo = this.handleCheckNo.bind(this);
        this.onInputBoxKeyDown = this.onInputBoxKeyDown.bind(this);
        this.dropDownShow = this.dropDownShow.bind(this);
        this.CurrencyHandler = this.CurrencyHandler.bind(this);
        this.CheckCurrencyHandler = this.CheckCurrencyHandler.bind(this);
        this.CurrencydropDownShow = this.CurrencydropDownShow.bind(this);
        this.validateDecimal = this.validateDecimal.bind(this);
    }
    componentDidMount() {
        const { reviewAndPayData } = this.props;
        let warrantyCost;
        if (reviewAndPayData && reviewAndPayData.residentialWarranty) {
            warrantyCost =
                reviewAndPayData.residentialWarranty.cost || reviewAndPayData.residentialWarranty.cost === 0
                    ? parseFloat(reviewAndPayData.residentialWarranty.cost)
                    : 0.0;
            warrantyCost = warrantyCost.toFixed(2);
            this.setState({
                TotatlWarrantyCost: warrantyCost,
                ActualWarrantyCost: warrantyCost,
                CheckAmount: warrantyCost,
            });
        }
    }
    // componentDidUpdate(nextProps: any, nextState: any) {
    //     if (nextProps.value !== this.props.value) {
    //       this.props.onChange(this.props.value);
    //     }
    //   }
    handlePopupClose() {
        this.props.hidePopsUp();
        document.body.classList.remove("hideOverflow");
    }
    handleClickCost = (e) => {
        this.setState({
            checked: !this.state.checked,
            hidebucks: !this.state.hidebucks,
        });
    };
    totalWarrantyCost(evt) {
        this.setState({
            TotatlWarrantyCost: evt.target.value,
        });
    }
    updateCheckAmount(evt) {
        this.setState({
            CheckAmount: evt.target.value,
        });
    }
    onBlurCheck = (e) => {
        this.doValidate();
    };
    dateSelection = (date) => {
        const CheckDepositDateError = "";
        this.setState(
            {
                CheckDepositDate: date,
                CheckDepositDateError,
            }
            // ,
            // () => {

            // if (!this.state.CheckDepositDate) {
            //     CheckDepositDateError = "Deposit date cannot to be empty";
            // }
            //     this.setState({
            //         CheckDepositDateError,
            //     });
            // }
        );
    };
    handleCheckNo(e) {
        this.setState(
            {
                CheckNumber: e.target.value,
            },
            () => {
                let CheckNumberError = "";
                if (!this.state.CheckNumber || !this.state.CheckNumber.trim()) {
                    CheckNumberError = "Check number cannot be empty";
                }
                this.setState({
                    CheckNumberError,
                });
            }
        );
    }
    onInputBoxKeyDown(event) {
        if (
            ["e", "E", "+"].includes(event.key) ||
            (event.key === "." && event.target.value.split(".").length > 1) ||
            (event.key === "-" && event.target.value.split("-").length > 1)
        ) {
            event.preventDefault();
        }
    }
    CurrencydropDownShow(e) {
        this.setState({
            isCurrencyDropDown: !this.state.isCurrencyDropDown,
        });
    }
    dropDownShow() {
        this.setState({
            isCheckCurrencyDropDown: !this.state.isCheckCurrencyDropDown,
        });
    }
    CurrencyHandler = (value) => {
        this.setState({ Currency: value });
    };
    CheckCurrencyHandler = (value) => {
        this.setState({ CheckCurrency: value });
    };
    doValidate() {
        const CheckAmount = this.state.CheckAmount ? parseFloat(this.state.CheckAmount) : null;
        const TotatlWarrantyCost = this.state.TotatlWarrantyCost ? parseFloat(this.state.TotatlWarrantyCost) : null;
        // let CheckAmountError = "";
        let TotatlWarrantyCostError, CheckAmountError, CheckNumberError, CheckDepositDateError;
        if (!TotatlWarrantyCost && TotatlWarrantyCost !== 0) {
            TotatlWarrantyCostError = "Warranty Cost cannot be empty";
        } else if (isNaN(TotatlWarrantyCost) || TotatlWarrantyCost < 0) {
            TotatlWarrantyCostError = "Warranty Cost cannot be less than zero";
        } else if (TotatlWarrantyCost >= 0) {
            this.setState({
                TotatlWarrantyCostError: "",
            });
        }
        if (this.state.checked) {
            if (!CheckAmount) {
                CheckAmountError = "Amount of check cannot be empty";
            } else if (isNaN(CheckAmount) || CheckAmount < 0) {
                CheckAmountError = "Amount of check cannot be less than zero";
            } else if (CheckAmount > TotatlWarrantyCost) {
                CheckAmountError = "Amount of check cannot be greater than Total Cost";
            } else if (CheckAmount <= TotatlWarrantyCost) {
                this.setState({
                    CheckAmountError: "",
                });
            }
            if (!this.state.CheckNumber || !this.state.CheckNumber.trim()) {
                CheckNumberError = "Check number cannot be empty";
            }
            if (!this.state.CheckDepositDate) {
                CheckDepositDateError = "Deposit date cannot be empty";
            }
        }
        if (TotatlWarrantyCostError || CheckNumberError || CheckAmountError || CheckDepositDateError) {
            this.setState({
                TotatlWarrantyCostError: TotatlWarrantyCostError,
                CheckNumberError: CheckNumberError,
                CheckAmountError: CheckAmountError,
                CheckDepositDateError: CheckDepositDateError,
            });
            return false;
        }
        return true;
    }
    validateError(e) {
        return this.doValidate();
    }
    completePayment(e) {
        e.preventDefault();
        // this.props.getReceivedDate(new Date(this.state.CheckDepositDate));
        const isValid = this.validateError(e);
        if (isValid) {
            const paymentObj = {};
            const {
                TotatlWarrantyCost,
                Currency,
                CheckAmount,
                CheckCurrency,
                CheckNumber,
                ActualWarrantyCost,
                CheckDepositDate,
            } = this.state;
            const { initiateTransaction, warrantyId } = this.props;
            paymentObj["warrantyId"] = warrantyId;
            paymentObj["TotatlWarrantyCost"] = parseFloat(TotatlWarrantyCost);
            paymentObj["ActualWarrantyCost"] = parseFloat(ActualWarrantyCost);
            paymentObj["Currency"] = Currency;
            // paymentObj["warrantyCost"] = warrantyCost;
            if (this.state.hidebucks) {
                paymentObj["CheckAmount"] = parseFloat(CheckAmount);
                paymentObj["CheckCurrency"] = CheckCurrency;
                paymentObj["CheckNumber"] = CheckNumber;
                paymentObj["CheckDepositDate"] = CheckDepositDate;
            }
            this.props.paymentActions.updateInitTransaction();
            this.props.goToCart(paymentObj);
            this.handlePopupClose();
        }
    }
    validateDecimal(e) {
        const t = e.target.value;
        const { maximum } = this.state;
        const intergerValue = t.split(".")[0];
        const decimalValue = t.split(".")[1];
        const maxIntergerValue = maximum.toString().split(".")[0];
        const maxDecimalValue = maximum.toString().split(".")[1];
        const prevValue = this.state[e.target.id];
        if (intergerValue.length > maxIntergerValue.length) {
            e.preventDefault();
            e.target.value = prevValue;
            return false;
        }
        if (decimalValue && decimalValue.length > maxDecimalValue.length) {
            e.preventDefault();
            e.target.value = prevValue;
            return false;
        }
        if (t.indexOf(".") >= 0) {
            e.target.value = t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3);
        }
    }
    render() {
        const { redirectUrl, reviewAndPayData, warrantyId, isTransactionInitiating } = this.props;
        const {
            isCurrencyDropDown,
            isCheckCurrencyDropDown,
            TotatlWarrantyCostError,
            CheckAmountError,
            CheckNumberError,
            CheckDepositDateError,
        } = this.state;
        //image CDN_PATH
        const getimagePath = imagePathurl();
        // if transaction completed, navigating to transaction completed page
        // if (redirectUrl) {
        //     removeWindowBeforeUnload();
        //     window.location.href = redirectUrl;
        //     return;
        // }
        if (redirectUrl) {
            let warrantyCost: any;
            if (reviewAndPayData && reviewAndPayData.residentialWarranty) {
                warrantyCost = reviewAndPayData.residentialWarranty.cost
                    ? parseFloat(reviewAndPayData.residentialWarranty.cost)
                    : "0";
            }
            ReactGA.event({
                category: "Go to payment",
                action: `Go to payment: ${warrantyId}`,
                label: `Go to payment: ${warrantyId} : ${warrantyCost}`,
            });
            removeWindowBeforeUnload();
            setTimeout(() => (window.location.href = redirectUrl), 300);
            return;
        }
        const checkBoxVal = this.state.checked;
        const schema = {
            const: {
                classNames: "gaf-datepicker",
                "ui:widget": "gaf_datePicker",
                "ui:options": {
                    label: false,
                },
                fromDate: "365",
                toDate: "0",
                format: "MM/DD/YYYY",
                family: "0",
                label: "Deposit date",
                description: "",
                placeholder: "MM/DD/YYYY",
                helpText: "",
            },
        };
        return (
            <React.Fragment>
                <div className="gaf-adjustcost-popup-container">
                    <div className="overlay" onClick={this.handlePopupClose}>
                        <div
                            className="gaf-adjustcost-popup"
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            <div id="close_popup" className="close-menu" onClick={this.handlePopupClose}>
                                <img className="close-modal-icon" src={`${getimagePath}close-mobile.png`} alt="close" />
                            </div>
                            <div className="adjustcost-popup-title ml13">Adjust warranty cost </div>

                            <div className="cost-container-sec">
                                <div className="col-sm-6 col-xs-12">
                                    <label className="label-contianer">Total warranty cost</label>
                                    <div
                                        className={
                                            TotatlWarrantyCostError ? "paymenterror-boundry" : "cost-inputbox-rectangle"
                                        }
                                    >
                                        <CurrencyInput
                                            type="number"
                                            maskOptions={{ allowNegative: true }}
                                            className="gaf-inputBox"
                                            value={this.state.TotatlWarrantyCost}
                                            onChange={this.totalWarrantyCost}
                                            onKeyDown={(evt) => this.onInputBoxKeyDown(evt)}
                                            onBlur={(evt) => this.onBlurCheck(evt)}
                                            onInput={(e) => this.validateDecimal(e)}
                                            id="TotatlWarrantyCost"
                                            max={9999999.99}
                                            onPaste={(e) => specialCharacterCheck}
                                            onDrop={(e) => dropCheck(e, "number")}
                                        />
                                    </div>
                                    <div className="errorMsg">{TotatlWarrantyCostError}</div>
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <div
                                        className="gaf-currency-dropdown"
                                        onClick={(e) => this.CurrencydropDownShow(e)}
                                    >
                                        <img
                                            src={`${getimagePath}chevron-down.png`}
                                            className="chevron-down-thickred"
                                        />
                                        <p className="dropdown-selection" title={this.state.Currency}>
                                            {/* {this.state.Currency} */}
                                            <p> {this.state.Currency} </p>
                                        </p>
                                        {isCurrencyDropDown && (
                                            <ul className="dropdown-list">
                                                {CONFIG.CONFIG.currency.map((item, index) => {
                                                    return (
                                                        <li
                                                            key={index}
                                                            value={item}
                                                            onChange={(e) => this.CurrencyHandler(e)}
                                                        >
                                                            {item}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="text-center">
                                <button
                                    disabled={isTransactionInitiating}
                                    className="complete-payment-btn"
                                    onClick={this.completePayment}
                                >
                                    GO TO CART
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export function mapStateToProps(state: RootState) {
    return {
        formId: state.dynamicFormInfo.formId,
        warrantyId: state.dynamicFormInfo.warrantyId,
        formData: state.dynamicFormInfo.warrantyInfo,
        reviewAndPayData: state.dynamicFormInfo.reviewAndPayData,
        redirectUrl: state.payments.redirectUrl,
        isTransactionInitiating: state.payments.isTransactionInitiating,
    };
}
/**
 * @function mapDispatchToProps
 * @param dispatch
 * @description :This function will dispatch
 * action following.
 */
export function mapDispatchToProps(dispatch: Dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
        globalActions: bindActionCreators(globalActionsCreator, dispatch),
        initiateTransaction: bindActionCreators(TransactionActionCreator.initiateTransaction, dispatch),
        paymentActions: bindActionCreators(TransactionActionCreator, dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AdjustCost);
